import React from 'react';
import { IoIosDocument } from 'react-icons/io';
import { FaFilePdf } from 'react-icons/fa';
import { WHITE } from './Colors';

const PDF_RED = '#E04F4F';

const isPdfFile = ({ isPdf, type, format, mime, name, fileName }) => {
    if (isPdf) return true;

    const normalizedType = String(type || '').toLowerCase();
    const normalizedFormat = String(format || '').toLowerCase();
    const normalizedMime = String(mime || '').toLowerCase();
    const normalizedName = String(name || fileName || '').toLowerCase();

    return (
        normalizedMime === 'application/pdf' ||
        normalizedType === 'application/pdf' ||
        normalizedFormat === 'pdf' ||
        normalizedName.endsWith('.pdf')
    );
};

function FileIcon({ size, color, backgroundColor, isPdf, type, format, mime, name, fileName, ...rest }) {
    const isPdfDocument = isPdfFile({ isPdf, type, format, mime, name, fileName });
    const Icon = isPdfDocument ? FaFilePdf : IoIosDocument;

    return (
        <div
            style={{
                backgroundColor: backgroundColor || (isPdfDocument ? PDF_RED : 'cornflowerblue'),
                justifyContent: 'center',
                height: 40,
                width: 40,
                alignItems: 'center',
                // marginRight: 8,
                display: 'flex',
                borderRadius: 50
            }}
        >
            <Icon
                size={size ? size : (isPdfDocument ? 21 : 24)}
                color={color ? color : WHITE}
                {...rest}
            />
        </div>
    );
}

export default FileIcon;
